import React from "react";
import "./style.scss";

const Spinner = (params) => (<div className="loader"></div>)

export default Spinner;